module.exports = __webpack_public_path__ + "img/service-06.b5cbff75.jpg";